import React, { useEffect, useState } from 'react';
import { Label } from 'edozvola-frontend-lib/dist/ui';
import { Col, Form, FormGroup, Input, Row } from 'reactstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { ERRORS } from 'app/config/constants';
import { showToast } from 'app/shared/util/toast.util';
import { toast } from 'react-toastify';
import { CaseAuthorityModel } from 'app/edozvola/cases/cases.model';
import { fetchCaseAuthority } from 'app/edozvola/cases/service/cases.service';

const CaseAuthorityForm = () => {
  const { id } = useParams<{ id: string }>();
  const [initialData, setInitialData] = useState<CaseAuthorityModel>({} as CaseAuthorityModel);
  const navigate = useNavigate();
  const [readonly, setReadonly] = useState(true);

  useEffect(() => {
    fetchCaseAuthority(id)
      .then(data => {
        setReadonly(data.readonly);
        setInitialData(data);
      })
      .catch(error => {
        if (Object.values(ERRORS).includes(error.response?.data?.detail)) {
          showToast(toast.error, error.response?.data?.detail);
        } else {
          showToast(toast.error, ERRORS.GENERIC_ERROR);
        }
        navigate('/cases/');
      });
  }, [id]);

  return (
    <>
      <h5 className={'form-header'}>Tijelo nadležno za izdavanje akta</h5>
      <Form>
        <Row>
          <Col xs={8}>
            <FormGroup>
              <Label labelText={'Nadležno tijelo'} />
              <Input disabled={readonly} value={initialData.authority} />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={8}>
            <FormGroup>
              <Label labelText={'Upravna jedinica'} />
              <Input disabled={readonly} value={initialData.administrativeUnit} />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={8}>
            <FormGroup>
              <Label labelText={'Naselje'} />
              <Input disabled={readonly} value={initialData.administrativeUnitCity} />
            </FormGroup>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default CaseAuthorityForm;
